import { ChevronLeft, ChevronRight } from "lucide-react";
import { cn } from "../../../lib/utils";
import { Button } from "../../button";
import { useDateFnsFormattersWithLocale } from "@tellescope/react-hooks";

export interface LabScreeningDateNavProps {
  dates: string[];
  selectedDate: string;
  onDateChange: (date: string) => void;
  className?: string;
}

export const LabScreeningDateNav = ({ dates, selectedDate, onDateChange, className }: LabScreeningDateNavProps) => {
  const { format } = useDateFnsFormattersWithLocale();
  const currentIndex = dates.indexOf(selectedDate);
  const hasPrev = currentIndex < dates.length - 1;
  const hasNext = currentIndex > 0;

  const goOlder = () => {
    const olderDate = dates[currentIndex + 1];
    if (hasPrev && olderDate) {
      onDateChange(olderDate);
    }
  };

  const goNewer = () => {
    const newerDate = dates[currentIndex - 1];
    if (hasNext && newerDate) {
      onDateChange(newerDate);
    }
  };

  const formattedDate = format(new Date(selectedDate + "T00:00:00"), "MMM d, yyyy");

  return (
    <div data-slot="lab-screening-date-nav" className={cn("flex items-center justify-center gap-2", className)}>
      <Button
        variant="ghost"
        onClick={goOlder}
        disabled={!hasPrev}
        className={cn(
          "p-1 rounded-md transition-colors",
          hasPrev
            ? "text-gray-500 hover:text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:text-gray-200 dark:hover:bg-gray-800"
            : "text-gray-200 cursor-not-allowed dark:text-gray-700"
        )}
      >
        <ChevronLeft size={16} />
      </Button>
      <span className="text-xs font-medium text-gray-600 dark:text-gray-400 min-w-[100px] text-center">
        {formattedDate}
      </span>
      <Button
        variant="ghost"
        onClick={goNewer}
        disabled={!hasNext}
        className={cn(
          "p-1 rounded-md transition-colors",
          hasNext
            ? "text-gray-500 hover:text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:text-gray-200 dark:hover:bg-gray-800"
            : "text-gray-200 cursor-not-allowed dark:text-gray-700"
        )}
      >
        <ChevronRight size={16} />
      </Button>
    </div>
  );
};
